var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-group',[_c('v-list-item',{attrs:{"link":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-list-item-action',{staticClass:"mr-2"},[_c('v-checkbox',{on:{"input":toggle,"change":_vm.emitAnswer},model:{value:(active),callback:function ($$v) {active=$$v},expression:"active"}})],1),_c('v-list-item-content',[_vm._v("Прочитал(а)")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }